import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Submit from "../components/Submit";
import { connects } from "../lib/metamask";
import { RootState } from "../store/reducers";
import { updateLoading } from "../store/reducers/loading";
import { updateAddress } from "../store/reducers/metamask";
import { color, intaglio, levelBtn, pageSetting } from "../styles/theme";
import HunterDashboard from "./HunterDashboard";
import Report from "./Report";

interface IViewDetail {
	data: any;
}

const ViewDetail = ({ data }: IViewDetail) => {
	const [toggle, setToggle] = useState(false);
	const { address } = useSelector((state: RootState) => state.metamask);
	const dispatch = useDispatch();

	const handleConnectMetamask = async () => {
		dispatch(updateLoading(true));
		const address = await connects.connect();
		dispatch(updateAddress(address?.address));
		dispatch(updateLoading(false));
	};

	const onClickHandler = async () => {
		// todo  address가 멤버에 속해 있다면 아니라면 메타마스크 연결
		true && (await handleConnectMetamask());
		setToggle(true);
	};
	return (
		<>
			{toggle ? (
				// <Report></Report>
				<HunterDashboard></HunterDashboard>
			) : (
				<ViewDetailSection>
					<div className="title">
						<h2>{data.projectName}</h2>
						<Submit text="Join" onClick={onClickHandler} />
					</div>

					{/* <TitleBox>
						<div className="thead">
							<span>Reward</span>
							<span>Bounty Area</span>
							<span>Members</span>
						</div>
						<div style={{ display: "flex" }}>
							<span>${data.reward}</span>
							<span>SmartContract</span>
							<span>{data.members.length}</span>
						</div>
					</TitleBox> */}
					<div className="titleSection">
						<TitleBox>
							<span className="subTitle">Reward</span>
							<span>
								${data.bounty} - {data.reward}
							</span>
						</TitleBox>
						<TitleBox>
							<span className="subTitle">Bounty Area</span>
							{/* <span>SmartContract</span> */}
							<span>{data.area}</span>
						</TitleBox>
						<TitleBox>
							<span className="subTitle">Members</span>
							<span>{data.members.length}</span>
						</TitleBox>
					</div>

					<DescriptBox>
						<h2>Description</h2>
						<span>
							Wormhole is a generic cross-chain messaging protocol that allows smart contracts on
							various blockchains to communicate with each other. Messages are routed from chain to
							chain by a decentralised group of guardian nodes who sign attestations of on-chain
							state. For more information about Wormhole, please visit https://wormhole.com/. This
							bug bounty program is focused on the prevention of negative impacts to Wormhole and
							the Portal Token Bridge, which currently covers their smart contracts, guardian nodes,
							and Wormhole integrations with blockchains. Submission Requirements All reports must
							come with sufficient explanation and data to easily reproduce the bug, e.g. through a
							proof-of-concept code. For a bug report to be paid, we do require the bug reporter to
							comply with our KYC requirements.
						</span>
					</DescriptBox>

					<DescriptBox>
						<h2>Rewards by Threat Level</h2>
						<span>
							Tier 1: Ability to Extract the complete TVL of all chains: Up to $10,000,000 USDC Tier
							2: Ability to Extract the complete TVL of a single chain: Up to $2,500,000 USDC Tier
							3: Ability to Brick the complete TVL of one or many chains: Up to $1,000,000 USDC All
							rewards are decided on a case-by-case basis, taking into account the exploitability of
							the bug, the impact it causes, and the likelihood of the vulnerability presenting
							itself if it is nondeterministic or some of the conditions are not present at the
							time. The rewards presented in the payout structure above are the maximum rewards and
							there are no minimum rewards. Rewards for critical vulnerabilities are further capped
							at 10% of extractable value during a 24h period. Rewards for vulnerabilities resulting
							in the indefinite locking of funds are further capped at 1% of destroyable value.
							Value is calculated based on the current market value and available liquidity for
							widely-used tokens in the Portal Token Bridge, e.g.
							<LevelRow>
								<div className="level" style={{ background: color.red }}>
									Critical
								</div>

								<div className="columnBox">
									<span>$ 1000000</span>
									<span>payout</span>
								</div>

								<div className="columnBox">
									<span>SmartContract</span>
									<span> </span>
								</div>
							</LevelRow>
							<LevelRow>
								<div className="level" style={{ background: color.yellow }}>
									High
								</div>

								<div className="columnBox">
									<span>$ 900000</span>
									<span>payout</span>
								</div>

								<div className="columnBox">
									<span>SmartContract</span>
									<span> </span>
								</div>
							</LevelRow>
							<LevelRow>
								<div className="level" style={{ background: color.blue }}>
									Medium
								</div>

								<div className="columnBox">
									<span>$ 70000</span>
									<span>payout</span>
								</div>

								<div className="columnBox">
									<span>SmartContract</span>
									<span> </span>
								</div>
							</LevelRow>
							<LevelRow>
								<div className="level" style={{ background: color.violet }}>
									Low
								</div>

								<div className="columnBox">
									<span>$ 40000</span>
									<span>payout</span>
								</div>

								<div className="columnBox">
									<span>SmartContract</span>
									<span> </span>
								</div>
							</LevelRow>
						</span>
					</DescriptBox>

					<DescriptBox>
						<h2>Source Code</h2>
						<span>
							{[
								"https://github.com/BaroqueWorks-hackathon/BaroqueWorks-frontend",
								"https://github.com/with-key/practice_radix_ui.git",
								"https://github.com/perifinance/peri.staking.git",
							].map((el) => (
								<SourceCodeList>
									<>{el}</>
									<button>Link</button>
								</SourceCodeList>
							))}
						</span>
					</DescriptBox>
				</ViewDetailSection>
			)}
		</>
	);
};

const ViewDetailSection = styled.section`
	${pageSetting}

	width: 100%;
	padding: 0 20rem;

	.titleSection {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	.title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 6.25rem;

		h2 {
			font-size: 4rem;
			margin: 0;
		}
	}
`;
const TitleBox = styled.div`
	${intaglio}

	flex-direction: column;
	justify-content: space-between;
	border-radius: 0.3rem;
	padding: 1rem;
	width: 15rem;
	height: 7rem;
	box-sizing: border-box;

	margin-top: 6rem;
	margin-bottom: 4rem;

	.subTitle {
		font-size: 1.6rem;
		font-weight: bold;
	}

	.thead {
		display: flex;
		padding-bottom: 1rem;
		border-bottom: 1px solid ${color.green};
		margin-bottom: 1rem;
	}

	span {
		display: flex;
		width: 15rem;
	}
`;

const DescriptBox = styled.div`
	width: 100%;
	margin-bottom: 3rem;

	h2 {
		font-size: 2.4rem;
		line-height: 3.9375rem;
	}

	span {
		${intaglio};

		display: flex;
		flex-direction: column;
		padding: 1rem 2rem;
		box-sizing: border-box;
		font-size: 1rem;
		line-height: 2rem;
	}
`;

const LevelRow = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	height: 5rem;
	background: ${color.lightGreen};
	border-radius: 13px;
	padding: 1rem 3rem;
	margin: 1rem 0;
	box-sizing: border-box;

	.level {
		${levelBtn}
	}

	.columnBox {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		min-width: 10rem;
		margin-left: 6rem;

		span {
			background: none;
			margin: 0;
			padding: 0;
			box-shadow: none;
			border-radius: 0;
			line-height: 24px;
		}
	}
`;

const SourceCodeList = styled.div`
	display: flex;
	justify-content: space-between;
	/* border-bottom: 1px solid #202020; */
	margin-bottom: 1rem;

	&:last-child {
		border-bottom: 0;
	}

	button {
		background: none;
		border-radius: 13px;
		color: ${color.white};
		cursor: pointer;
	}
`;

export default ViewDetail;
